import user from './modules/user'
import getters from './getters'
import { createStore } from 'vuex';

export default createStore({
  modules: {
    user,
  },
  state: {},
  mutations: {},
  actions: {},
  getters
})
